import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import parse from 'html-react-parser';
import { parseMarginPadding } from '../controlUtils';

export function displayGraphUtil(obj, entryPoint){

    const content = JSON.parse(obj.Content);
    const type = parse(content.Type);
    const title = parse(content.Title);
    const theme = content.Theme;
    const size = content.Size;
    const marginPadding = content.MarginPadding;
    
    const mp = parseMarginPadding(marginPadding);
    const options = (type == "pie")? pieOptions(content): barOptions(content);

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    let titleSz = 0; let textSz = 0; let zoom = 0;
    if(size == "small"){ titleSz=20; textSz=16 }
    else if(size == "medium"){ titleSz=24; textSz=18 }
    else if(size == "large"){ titleSz=34; textSz=24 }

    if(entryPoint == "presentation" && obj.Presentation != ""){
        const ptn = JSON.parse(obj.Presentation);
        if(ptn.TitleSize != "") { titleSz = parseInt(ptn.TitleSize) }
        if(ptn.TextSize != "") { textSz = parseInt(ptn.TextSize) }
        if(ptn.Zoom != "") { zoom = parseInt(ptn.Zoom) }
    }

    if(entryPoint == "editor"){
        zoom = 60;
    }

    const styles = {
        conatiner:{
            flex: 1,
            maxWidth: (obj.ContainerId > 0)? 360: '100%',
            background: bgColor,
            zoom: `${zoom}%`, 
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
        },
        title: {
            color: txtColor,
            textAlign: 'center',
            fontSize: titleSz,
            fontWeight: 600
        }
    }

    return (
        <div style={styles.conatiner} className={"graph"}>
            {(title != "") &&
                <h4 style={styles.title} className = 'element-title'>{parse(title)}</h4>
            }
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />
        </div>
    )
}

function barOptions(obj){

    const categories = obj.Data.map(x => x.Name);
    let series = [];
    if(obj.MultiSeries){

    }else{
        series = [
            {
                name: obj.XTitle,
                data: obj.Data.map(x => parseInt(x.Value))
            }
        ]
    }

    const options = {
        chart: {
            type: obj.Type
        },
        title: {
            text: ""
        },
        xAxis: {
            categories: categories,
        },
        yAxis: {
            title: {
                text: obj.YTitle
            }
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: series
    }

    return options;
}

function pieOptions(obj){

    let series = [];
    if(obj.MultiSeries){

    }else{
        series = obj.Data.map(({ Name, Value }) => ({ name: Name, y: parseFloat(Value) }));
    }

    const options = {
        chart: {
            type: 'pie'
        },
        title: {
            text: ""
        },
        tooltip: {
            valueSuffix: '%'
        },
        plotOptions: {
            pie: {
                size: '100%', 
            },
            series: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: [
                    {
                        enabled: true,
                        distance: 10
                    }, 
                    {
                        enabled: true,
                        distance: -40,
                        format: '{point.percentage:.1f}%',
                        style: {
                            fontSize: '1.2em',
                            textOutline: 'none',
                            opacity: 0.7
                        },
                        filter: {
                            operator: '>',
                            property: 'percentage',
                            value: 10
                        }
                    }
                ]
            }
        },
        series: [
            {
                name: 'Percentage',
                colorByPoint: true,
                data: series
            }
        ]
    }

    return options;
}


